import { IAddMedicationAdministeredStateList } from '../../addMedicationAdministered/store/addMedicationAdministered.types'
import { IIntubationStateList } from '../../intubation/store/intubation.types'
import { IPatient, IPcr } from '../../pcr/store/pcr.types'
import { IAirwayStateList } from '../../procedures/airway/store/airway.types'
import { IBloodProductAdministrationStateList } from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.types'
import { IAssessmentStateList } from '../../procedures/assessment/store/assessment.types'
import { IChildbirthOBStateList } from '../../procedures/childbirthOB/store/childbirthOB.types'
import { ICriticalCareStateList } from '../../procedures/criticalCare/store/criticalCare.types'
import { IDrainStateList } from '../../procedures/drain/store/drain.types'
import { IExtricationStateList } from '../../procedures/extrication/store/extrication.types'
import { IHospitalNotifyStateList } from '../../procedures/hospitalNotify/store/hospitalNotify.types'
import { IImmobilizationStateList } from '../../procedures/immobilization/store/immobilization.types'
import { IInitiateIvStateList } from '../../procedures/initiateIv/store/initiateIv.types'
import { ILabsStateList } from '../../procedures/labs/store/labs.types'
import { IMedicalConsultStateList } from '../../procedures/medicalConsult/store/medicalConsult.types'
import { IOperationsStateList } from '../../procedures/operations/store/operations.types'
import { IRescueStateList } from '../../procedures/rescue/store/rescue.types'
import { ITitrateStateList } from '../../procedures/titrate/store/titrate.types'
import { IVentilatorStateList } from '../../procedures/ventilator/store/ventilator.types'
import { IVentricularAssistDeviceStateList } from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.types'
import { IWoundCareStateList } from '../../procedures/woundCare/store/woundCare.types'
import { IPatientVitalsList } from '../../vitals/store/vitals.types'
import { IItem, ProcedureAndVitalsStateListName } from '../store/timeline.types'

export const updateProcedureOnReorder = (pcrDoc: IPcr, selectedItem: IItem, updatedPatient: IPatient): IPatient => {
  const itemType = selectedItem.event

  if (itemType === 'Vitals') {
    const vitalstateList = updateProcedureOnReorderHelper(pcrDoc, 'patientVitals', selectedItem)
    if (vitalstateList) {
      updatedPatient = {
        ...updatedPatient,
        patientVitals: vitalstateList as IPatientVitalsList,
      }
    }
  } else if (itemType === 'Airway') {
    const airwayStateList = updateProcedureOnReorderHelper(pcrDoc, 'airwayStateList', selectedItem)
    if (airwayStateList) {
      updatedPatient = {
        ...updatedPatient,
        airwayStateList: airwayStateList as IAirwayStateList,
      }
    }
  } else if (itemType === 'Medication Administered') {
    const medicationStateList = updateProcedureOnReorderHelper(pcrDoc, 'medicationAdministeredStateList', selectedItem)
    if (medicationStateList) {
      updatedPatient = {
        ...updatedPatient,
        medicationAdministeredStateList: medicationStateList as IAddMedicationAdministeredStateList,
      }
    }
  } else if (itemType === 'Ventilator') {
    const ventilatorStateList = updateProcedureOnReorderHelper(pcrDoc, 'ventilatorStateList', selectedItem)
    if (ventilatorStateList) {
      updatedPatient = {
        ...updatedPatient,
        ventilatorStateList: ventilatorStateList as IVentilatorStateList,
      }
    }
  } else if (itemType === 'Cardiac') {
    const ventilatorStateList = updateProcedureOnReorderHelper(pcrDoc, 'ventilatorStateList', selectedItem)
    if (ventilatorStateList) {
      updatedPatient = {
        ...updatedPatient,
        ventilatorStateList: ventilatorStateList as IVentilatorStateList,
      }
    }
  } else if (itemType === 'Drain') {
    const drainStateList = updateProcedureOnReorderHelper(pcrDoc, 'drainStateList', selectedItem)
    if (drainStateList) {
      updatedPatient = {
        ...updatedPatient,
        drainStateList: drainStateList as IDrainStateList,
      }
    }
  } else if (itemType === 'Initiate IV') {
    const initiateIvStateList = updateProcedureOnReorderHelper(pcrDoc, 'initiateIvStateList', selectedItem)
    if (initiateIvStateList) {
      updatedPatient = {
        ...updatedPatient,
        initiateIvStateList: initiateIvStateList as IInitiateIvStateList,
      }
    }
  } else if (itemType === 'Hospital Notify') {
    const hospitalNotifyStateList = updateProcedureOnReorderHelper(pcrDoc, 'hospitalNotifyStateList', selectedItem)
    if (hospitalNotifyStateList) {
      updatedPatient = {
        ...updatedPatient,
        hospitalNotifyStateList: hospitalNotifyStateList as IHospitalNotifyStateList,
      }
    }
  } else if (itemType === 'Intubation') {
    const intubationStateList = updateProcedureOnReorderHelper(pcrDoc, 'intubationStateList', selectedItem)
    if (intubationStateList) {
      updatedPatient = {
        ...updatedPatient,
        intubationStateList: intubationStateList as IIntubationStateList,
      }
    }
  } else if (itemType === 'Operations') {
    const operationsStateList = updateProcedureOnReorderHelper(pcrDoc, 'operationsStateList', selectedItem)
    if (operationsStateList) {
      updatedPatient = {
        ...updatedPatient,
        operationsStateList: operationsStateList as IOperationsStateList,
      }
    }
  } else if (itemType === 'Labs') {
    const labsStateList = updateProcedureOnReorderHelper(pcrDoc, 'labsStateList', selectedItem)
    if (labsStateList) {
      updatedPatient = {
        ...updatedPatient,
        labsStateList: labsStateList as ILabsStateList,
      }
    }
  } else if (itemType === 'Titrate') {
    const titrateStateList = updateProcedureOnReorderHelper(pcrDoc, 'titrateStateList', selectedItem)
    if (titrateStateList) {
      updatedPatient = {
        ...updatedPatient,
        titrateStateList: titrateStateList as ITitrateStateList,
      }
    }
  } else if (itemType === 'Childbirth / OB') {
    const childbirthOBStateList = updateProcedureOnReorderHelper(pcrDoc, 'childbirthOBStateList', selectedItem)
    if (childbirthOBStateList) {
      updatedPatient = {
        ...updatedPatient,
        childbirthOBStateList: childbirthOBStateList as IChildbirthOBStateList,
      }
    }
  } else if (itemType === 'Extrication') {
    const extricationStateList = updateProcedureOnReorderHelper(pcrDoc, 'extricationStateList', selectedItem)
    if (extricationStateList) {
      updatedPatient = {
        ...updatedPatient,
        extricationStateList: extricationStateList as IExtricationStateList,
      }
    }
  } else if (itemType === 'Immobilization') {
    const immobilizationStateList = updateProcedureOnReorderHelper(pcrDoc, 'immobilizationStateList', selectedItem)
    if (immobilizationStateList) {
      updatedPatient = {
        ...updatedPatient,
        immobilizationStateList: immobilizationStateList as IImmobilizationStateList,
      }
    }
  } else if (itemType === 'Medical Consult') {
    const medicalConsultStateList = updateProcedureOnReorderHelper(pcrDoc, 'medicalConsultStateList', selectedItem)
    if (medicalConsultStateList) {
      updatedPatient = {
        ...updatedPatient,
        medicalConsultStateList: medicalConsultStateList as IMedicalConsultStateList,
      }
    }
  }
  // TODO enable this when EKG import is merged to dev
  /*else if (itemType === 'Pert Neg Med') {
      const pnMedicationStateList = updateProcedureOnReorderHelper(pcrDoc, 'date_pertNegMeds', selectedItem)
      if (pnMedicationStateList) {
        updatedPatient = {
          ...updatedPatient,
          date_pertNegMeds: pnMedicationStateList as IAddPnMedicationStateList,
        }
      }
    } else if (itemType === 'Pert Neg Proc') {
      const pnProcedureStateList = updateProcedureOnReorderHelper(pcrDoc, 'date_pertNegProcs', selectedItem)
      if (pnProcedureStateList) {
        updatedPatient = {
          ...updatedPatient,
          date_pertNegProcs: pnProcedureStateList as IPnProcedureStateList,
        }
      }
  } */
  else if (itemType === 'Rescue') {
    const rescueStateList = updateProcedureOnReorderHelper(pcrDoc, 'rescueStateList', selectedItem)
    if (rescueStateList) {
      updatedPatient = {
        ...updatedPatient,
        rescueStateList: rescueStateList as IRescueStateList,
      }
    }
  } else if (itemType === 'Wound Care') {
    const woundCareStateList = updateProcedureOnReorderHelper(pcrDoc, 'woundCareStateList', selectedItem)
    if (woundCareStateList) {
      updatedPatient = {
        ...updatedPatient,
        woundCareStateList: woundCareStateList as IWoundCareStateList,
      }
    }
  } else if (itemType === 'Ventricular Assist Device') {
    const ventricularAssistDeviceStateList = updateProcedureOnReorderHelper(
      pcrDoc,
      'ventricularAssistDeviceStateList',
      selectedItem
    )
    if (ventricularAssistDeviceStateList) {
      updatedPatient = {
        ...updatedPatient,
        ventricularAssistDeviceStateList: ventricularAssistDeviceStateList as IVentricularAssistDeviceStateList,
      }
    }
  } else if (itemType === 'Blood Product Administration') {
    const bloodProductAdministrationStateList = updateProcedureOnReorderHelper(
      pcrDoc,
      'bloodProductAdministrationStateList',
      selectedItem
    )
    if (bloodProductAdministrationStateList) {
      updatedPatient = {
        ...updatedPatient,
        bloodProductAdministrationStateList:
          bloodProductAdministrationStateList as IBloodProductAdministrationStateList,
      }
    }
  } else if (itemType === 'Critical Care') {
    const criticalCareStateList = updateProcedureOnReorderHelper(pcrDoc, 'criticalCareStateList', selectedItem)
    if (criticalCareStateList) {
      updatedPatient = {
        ...updatedPatient,
        criticalCareStateList: criticalCareStateList as ICriticalCareStateList,
      }
    }
  } else if (itemType === 'Assessment') {
    const assessmentsStateList = updateProcedureOnReorderHelper(pcrDoc, 'assessmentsStateList', selectedItem)
    if (assessmentsStateList) {
      updatedPatient = {
        ...updatedPatient,
        assessmentsStateList: assessmentsStateList as IAssessmentStateList,
      }
    }
  }
  return updatedPatient
}

const updateProcedureOnReorderHelper = (
  pcrDoc: IPcr,
  procedureStateListName: ProcedureAndVitalsStateListName,
  selectedItem: IItem
) => {
  const procedureAndVitalsStateList = pcrDoc.patient[procedureStateListName]
  if (!procedureAndVitalsStateList) return

  const procedureOrVitalIndex = procedureAndVitalsStateList.findIndex((procedureState: any) => {
    return procedureState.key === selectedItem.key
  })

  if (typeof procedureOrVitalIndex !== 'number' || procedureOrVitalIndex === -1) return

  const procedureOrVital =
    procedureAndVitalsStateList && procedureAndVitalsStateList.length > 0
      ? procedureAndVitalsStateList[procedureOrVitalIndex]
      : undefined

  if (procedureOrVital && selectedItem.labelHeader && selectedItem.subHeader) {
    const updatedProcedureOrVital = {
      ...procedureOrVital,
      time: selectedItem.labelHeader,
      date: selectedItem.subHeader,
      pta: !!selectedItem.labelHeaderFlag,
    }
    procedureAndVitalsStateList[procedureOrVitalIndex] = updatedProcedureOrVital
  }

  return procedureAndVitalsStateList
}
